import { shallowRef, ref, computed } from 'vue';
import { exitJournal } from '@/legacy/journal';
export const legacyJob = shallowRef(null), legacyLast = shallowRef(null), legacyStorageError = ref(''), legacyAttempting = ref(false);
export const legacyBusy = computed(() => legacyAttempting.value || !!legacyJob.value || !!legacyStorageError.value);
let generation = 0;
export async function refreshLegacyGate() {
  const version = ++generation;
  try {
    const active = await exitJournal.inspect(), last = await exitJournal.last();
    if (version === generation) { legacyJob.value = active; legacyLast.value = last; legacyStorageError.value = ''; }
    return active;
  } catch (error) { if (version === generation) legacyStorageError.value = '交易儲存不可用或記錄待核實，暫停新寫入。'; throw error; }
}
const blocked = () => Object.assign(Error('舊版退出交易待核實，請先到歷史權益查詢。'), { code: 'LEGACY_EXIT_PENDING' });
export async function ensureLegacyClear() {
  if (legacyAttempting.value) throw blocked();
  let active; try { active = await refreshLegacyGate(); } catch { throw blocked(); }
  if (legacyAttempting.value || active) throw blocked();
}
export function startLegacyAdmission(onRecover = () => {}) {
  let stopped = false;
  const refresh = () => refreshLegacyGate().then(active => { if (!stopped && active?.hash) onRecover(); }).catch(() => {});
  const visible = () => { if (document.visibilityState === 'visible') refresh(); };
  refresh();
  const timer = setInterval(visible, 5000);
  window.addEventListener('focus', visible); document.addEventListener('visibilitychange', visible);
  return () => { stopped = true; clearInterval(timer); window.removeEventListener('focus', visible); document.removeEventListener('visibilitychange', visible); };
}
